<template>
  <div class="tc-container">
    <ul>
      <li :class="actvIndex == 1 ? 'is-active' : ''" @click="handSelect(1)">
        今日
      </li>
      <li :class="actvIndex == 2 ? 'is-active' : ''" @click="handSelect(2)">
        近七天
      </li>
      <li :class="actvIndex == 3 ? 'is-active' : ''" @click="handSelect(3)">
        本月
      </li>
      <li :class="actvIndex == 4 ? 'is-active' : ''" @click="handSelect(4)">
        本年
      </li>
    </ul>
    <div class="tp-chart" ref="myChart"></div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {
        actvIndex: 3,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = {
          backgroundColor: 'transparent',
          tooltip: {},
          grid: {
            top: '8%',
            left: '1%',
            right: '1%',
            bottom: '8%',
            containLabel: true,
          },
          legend: {
            show: false,
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: true,
              axisLine: {
                //坐标轴轴线相关设置。数学上的x轴
                show: true,
                lineStyle: {
                  color: '#808487',
                },
              },
              axisLabel: {
                //坐标轴刻度标签的相关设置
                textStyle: {
                  color: '#E6E6E6',
                  margin: 15,
                },
              },
              axisTick: {
                show: false,
              },
              data: ['0', '2', '4', '6', '8', '10', '12'],
            },
          ],
          yAxis: [
            {
              type: 'value',
              min: 0,
              max: 20,
              splitNumber: 7,
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#4D5054',
                },
              },
              axisLine: {
                show: false,
              },
              axisLabel: {
                margin: 20,
                textStyle: {
                  color: '#d1e6eb',
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          series: [
            {
              name: '注册总量',
              type: 'line',
              // smooth: true, //是否平滑曲线显示
              // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
              symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
              symbolSize: 0,
              smooth: true,
              showAllSymbol: true,
              lineStyle: {
                normal: {
                  color: '#FFC600', // 线条颜色
                },
                borderColor: '#f0f',
              },
              label: {
                show: false,
                position: 'top',
                textStyle: {
                  color: '#fff',
                },
              },
              itemStyle: {
                normal: {
                  color: '#28ffb3',
                },
              },
              tooltip: {
                show: false,
              },
              areaStyle: {
                //区域填充样式
                normal: {
                  //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: 'transparent',
                      },
                      {
                        offset: 1,
                        color: 'transparent',
                      },
                    ],
                    false
                  ),
                  shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                  shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                },
              },
              data: [0, 1, 4, 18, 6, 14, 18],
            },
            {
              name: '最新注册量',
              type: 'bar',
              barWidth: 20,
              tooltip: {
                show: false,
              },
              label: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#fff',
                },
              },
              itemStyle: {
                normal: {
                  barBorderRadius: 0,
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#14c8d4',
                    },
                    {
                      offset: 1,
                      color: '#43eec6',
                    },
                  ]),
                  //   color: function (params) {
                  //     var colorList = [
                  //       '#0ec1ff',
                  //       '#10cdff',
                  //       '#12daff',
                  //       '#15ebff',
                  //       '#17f8ff',
                  //       '#1cfffb',
                  //       '#1dfff1',
                  //     ]
                  //     return colorList[params.dataIndex]
                  //   },
                },
              },
              data: [12, 3, 4, 18, 6, 14, 18],
            },
          ],
        }
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      color: #15a983;
      cursor: pointer;
      li {
        margin-right: 30px;
        white-space: nowrap;
      }
      .is-active {
        border-bottom: 1px solid #ffc600;
        padding-bottom: 7px;
        position: relative;
        color: #fff;
        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: 5px solid #ffc600;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          bottom: 0px;
          left: 37%;
        }
      }
    }
    .tp-chart {
      margin-top: 20px;
      width: 100%;
      height: 8.6vw;
    }
  }
</style>
